
declare const createUnityInstance: any;
import { defineComponent, onMounted, ref } from "vue";
import ParkHeader from "@/components/ParkHeader.vue";
import isMobile from "ismobilejs";
import store from "@/store/index";
import Utils from "@/components/Utils";
import CharaControl from "@/components/CharaControl.vue";
import Campaign from "@/components/Campaign.vue";
import Notice from "@/components/Notice.vue";

export default defineComponent({
  components: {
    ParkHeader,
    CharaControl,
    Campaign,
    Notice,
  },
  props: {
    isGlobalMenu: {
      type: Boolean,
    },
    isStart: {
      type: Boolean,
    },
    isShow: {
      type: Boolean,
    },
  },
  computed: {
    selectCampaign() {
      return store.state.selectCampaign;
    },
  },
  watch: {
    isStart(value) {
      if (value) this.start();
    },
    async selectCampaign(value) {
      if (!value) return;
      this.hidePavillion();
    },
  },
  setup(props) {
    const isLoaded = ref<boolean>(false);
    const parkHeader = ref<InstanceType<typeof ParkHeader>>();
    const unityContainer = ref<HTMLElement>();
    const unityCanvas = ref<HTMLElement>();
    const unityLoadingBar = ref<HTMLElement>();
    const pavillionContainer = ref<HTMLElement>();
    const pavillionName = ref<HTMLElement>();
    const pavillionUrl = ref<HTMLElement>();
    const pavillionIcon = ref<HTMLElement>();
    const isSound = ref<boolean>(false);
    const se = ref<HTMLAudioElement>();

    const cover = ref<HTMLElement>();
    const tap = () => {
      if (cover.value) cover.value.classList.remove("show");
      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "ClosePavillionWindow");
    };

    const enterPavillion = () => {
      const el = document.querySelector(".pavillion-container") as HTMLElement;
      el.classList.remove("show");
      const title = pavillionName.value ? pavillionName.value.innerText : "";
      if (pavillionUrl.value) {
        const url = pavillionUrl.value.getAttribute("data-url");
        if (!url) return;

        let position = 0;
        switch (title) {
          case "テクノロジーミュージアム":
            position = 2;
            break;
          case "バーチャル展示場":
            position = 3;
            break;
          case "マイクロドローン ルームフライト":
            position = 4;
            break;
          case "住まいと暮らしの豆知識":
            position = 5;
            break;
          case "ルームツアー":
            position = 6;
            break;
          case "リアルサイズモデルハウス":
            position = 7;
            break;
        }
        if (position !== 0)
          localStorage.setItem("virtual.last-position", position.toString());

        const newMemberCampaign = store.getters.getNewMemberCampaign;
        const loginCampaign = store.getters.getLoginCampaign;
        if (newMemberCampaign || loginCampaign) {
          store.commit("setIsLoginCampaignWindow", true);
        }

        const unityInstance = store.state.unityInstance;
        unityInstance.SendMessage("[GameManager]", "EnterPavillion", title);

        if (pavillionIcon.value && isSound.value) {
          const name = pavillionIcon.value.getAttribute("data-name");
          new Audio(`sounds/pavilion/${name}.mp3`).play();
        }

        setTimeout(() => {
          if (
            iPhone &&
            /(fbios|fb_iab|instagram)/i.test(
              navigator.userAgent.toLocaleLowerCase()
            )
          ) {
            const iframe = document.createElement("iframe");
            iframe.src = url;
            iframe.className = "pavillion-frame";
            document.body.appendChild(iframe);

            const app = document.querySelector<HTMLElement>("#app");
            if (app) app.style.display = "none";

            history.pushState(
              null,
              "ジョーズ・タウン 一条の住まいを楽しく体験できるバーチャル空間｜一条工務店 - 住宅メーカー（ハウスメーカー）",
              url
            );
          } else {
            window.open(url, "ichijo");
          }
        }, 300);
      }
    };

    const hidePavillion = () => {
      const el = document.querySelector(".pavillion-container") as HTMLElement;
      el.classList.remove("show");
      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "ClosePresentWindow");
    };

    const enterPresent = () => {
      const el = document.querySelector(".present-container") as HTMLElement;
      el.classList.remove("show");
      // const unityInstance = store.state.unityInstance;
      // unityInstance.SendMessage("[GameManager]", "PlaySound", 0);
      if (se.value && isSound.value) se.value.play();

      setTimeout(() => {
        location.href = `${location.origin}/virtual/present/`;
        // window.open(`${location.origin}/virtual/present/`, "ichijo");
      }, 300);
    };

    const hidePresent = () => {
      const el = document.querySelector(".present-container") as HTMLElement;
      el.classList.remove("show");
      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "ClosePresentWindow");

      setTimeout(() => {
        if (store.state.isLoginCampaignWindow) {
          store.commit("setIsLoginCampaignWindow", false);
          let campaign = store.getters.getNewMemberCampaign;
          if (campaign) {
            store.commit("setSelectCampaign", campaign);
            return;
          }
          campaign = store.getters.getLoginCampaign;
          if (campaign) {
            store.commit("setSelectCampaign", campaign);
            return;
          }
        }

        store.commit("setReadyNotice", true);
      }, 500);
    };

    const iPhone = isMobile(window.navigator).apple.phone;
    let resizeFlag = false;
    const resize = () => {
      let height = Utils.contentHeight("px");
      if (resizeFlag && iPhone) {
        height = "calc(100vh - 50px)";
        resizeFlag = false;
      }

      if (unityContainer.value) unityContainer.value.style.height = height;
      // if (pavillionContainer.value)
      //   pavillionContainer.value.style.height = height;
      if (cover.value) cover.value.style.height = height;
      if (unityLoadingBar.value) unityLoadingBar.value.style.height = height;
      if (unityCanvas.value) {
        unityCanvas.value.style.height = height;
        unityCanvas.value.style.width = "100vw";
      }

      if (parkHeader.value) parkHeader.value.resize();

      if (window.innerHeight !== document.documentElement.clientHeight)
        resizeFlag = true;
    };

    const toggleSound = (value: boolean) => {
      isSound.value = value;
    };

    const campaign = async () => {
      let list: Campaign[] = store.state.campaign;
      if (!list.length) {
        list = await Utils.getCampaign();
        store.commit("setCampaign", list);
      }

      const types = [];
      for (const v of list) {
        if (!v.canApply) continue;
        types.push(v.type);
      }

      return types.join();
    };

    onMounted(() => {
      resize();
      window.addEventListener("resize", () => resize());
      if (iPhone) window.addEventListener("scroll", () => scroll());

      if (props.isStart) start();

      if (iPhone) {
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState !== "visible") {
            cover.value?.classList.add("show");
          }
        });
      }

      window.addEventListener("keydown", (event) => {
        const pavillion = document.querySelector(
          ".pavillion-container"
        ) as HTMLElement;
        const present = document.querySelector(
          ".present-container"
        ) as HTMLElement;

        if (event.code === "Enter") {
          if (pavillion.classList.contains("show")) enterPavillion();
          if (present.classList.contains("show")) enterPresent();
        } else if (event.code === "KeyQ") {
          if (pavillion.classList.contains("show")) hidePavillion();
          if (present.classList.contains("show")) hidePresent();
        }
      });
    });

    const start = async () => {
      const isLogin = await Utils.isLogin();
      if (!isLogin) {
        location.href = `${Utils.baseUrl}/virtual/login/`;
        return;
      }

      if (!unityCanvas.value || !unityLoadingBar.value) return;
      const canvas = unityCanvas.value;
      const loadingBar = unityLoadingBar.value;
      const progressBarFull = document.querySelector(
        "#unity-progress-bar-full"
      ) as HTMLElement;
      const warningBanner = document.querySelector(
        "#unity-warning"
      ) as HTMLElement;

      function unityShowBanner(msg: string, type = "") {
        function updateBannerVisibility() {
          warningBanner.style.display = warningBanner.children.length
            ? "block"
            : "none";
        }
        var div = document.createElement("div");
        div.innerHTML = msg;
        warningBanner.appendChild(div);
        if (type == "error") {
          div.style.background = "red";
          div.style.padding = "10px";
        } else {
          if (type == "warning") {
            div.style.background = "yellow";
            div.style.padding = "10px";
          }
          setTimeout(function () {
            warningBanner.removeChild(div);
            updateBannerVisibility();
          }, 5000);
        }
        updateBannerVisibility();
      }

      const hash = "?" + Date.now();
      var buildUrl = "./Build";
      var config = {
        dataUrl: buildUrl + "/app.data" + hash,
        frameworkUrl: buildUrl + "/app.framework.js" + hash,
        codeUrl: buildUrl + "/app.wasm" + hash,
        streamingAssetsUrl: "StreamingAssets",
        companyName: "DefaultCompany",
        productName: "IchijoPark",
        productVersion: "0.1",
        showBanner: unityShowBanner,
      };

      if (iPhone) {
        window.addEventListener("blur", () => {
          if (cover.value) cover.value.classList.add("show");
        });
      }

      loadingBar.style.display = "block";

      const types = await campaign();

      var script = document.createElement("script");
      script.src = buildUrl + "/app.loader.js" + hash;
      script.onload = () => {
        createUnityInstance(canvas, config, (progress: number) => {
          progressBarFull.style.width = 100 * progress + "%";
        })
          .then((unityInstance: any) => {
            store.commit("setUnityInstance", unityInstance);
            loadingBar.style.display = "none";
            isLoaded.value = true;

            setInterval(() => {
              unityInstance.SendMessage(
                "[GameManager]",
                "RequestCharacterPosition"
              );
            }, 1000);

            if (types) {
              unityInstance.SendMessage(
                "CampaignManager",
                "CampaignList",
                types
              );
            }

            store.commit("setReady", true);
          })
          .catch((message: string) => {
            alert(message);
          });
      };
      document.body.appendChild(script);
    };

    return {
      start,
      isLoaded,
      enterPavillion,
      hidePavillion,
      enterPresent,
      hidePresent,
      unityContainer,
      unityCanvas,
      unityLoadingBar,
      parkHeader,
      pavillionContainer,
      pavillionName,
      pavillionUrl,
      pavillionIcon,
      cover,
      tap,
      toggleSound,
      se,
    };
  },
});
